import { render } from "./Cogwheel.vue?vue&type=template&id=5707e051&scoped=true"
import script from "./Cogwheel.vue?vue&type=script&lang=js"
export * from "./Cogwheel.vue?vue&type=script&lang=js"

import "./Cogwheel.vue?vue&type=style&index=0&id=5707e051&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5707e051"]])

export default __exports__